import { FC, Fragment, useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { OnlineshopProductImages } from '../../../../../../../../Interface/OnlineshopProductImages';
import QuickViewImageBadges, {
  QuickViewImageBadgesProps,
} from './QuickViewImageBadges';
import depositBadgeImage from '../../../../../../../../../public/images/pfand_img.webp'
import styles from './ProductQuickViewModal.module.scss?module';

type MainImageT = { name: string; src: string };

interface QuickViewDesktopGalleryProps {
  images: OnlineshopProductImages;
  badgesProps: QuickViewImageBadgesProps & { isDepositProduct?: boolean };
}

const QuickViewDesktopGallery: FC<QuickViewDesktopGalleryProps> = ({
  images,
  badgesProps,
}) => {
  const getFirstAvailableImage = (): MainImageT => {
    if (images.front_image_url) {
      return { name: 'front_image_url', src: images.front_image_url };
    }
    if (images.nutrition_facts_image_url) {
      return {
        name: 'nutrition_facts_image_url',
        src: images.nutrition_facts_image_url,
      };
    }
    const firstSellSheet = images.sell_sheets?.find((s) => s.image_url);
    if (firstSellSheet?.image_url) {
      return { name: 'image_url-1', src: firstSellSheet.image_url };
    }
    return { name: 'front_image_url', src: '' };
  };

  const defaultImage = getFirstAvailableImage();
  const [mainImage, setMainImage] = useState<MainImageT>(defaultImage);

  useEffect(() => {
    setMainImage(getFirstAvailableImage());
  }, [images]);

  const selectImage = ({ name, src }: MainImageT) => {
    if (src && src !== mainImage.src) {
      setMainImage({ name, src });
    }
  };

  return (
    <div className={styles.GalleryGrid}>
      <div className={styles.Thumbnails}>
        {images.front_image_url?.length > 0 && (
          <Image
            className={
              mainImage.name === 'front_image_url'
                ? styles.ThumbnailActive
                : styles.Thumbnail
            }
            src={images.front_image_url}
            style={{ objectFit: 'contain', objectPosition: 'center' }}
            onClick={() =>
              selectImage({
                name: 'front_image_url',
                src: images.front_image_url,
              })
            }
          />
        )}

        {images.nutrition_facts_image_url?.length > 0 && (
          <Image
            className={
              mainImage.name === 'nutrition_facts_image_url'
                ? styles.ThumbnailActive
                : styles.Thumbnail
            }
            src={images.nutrition_facts_image_url}
            style={{
              objectFit: 'none',
              objectPosition: 'left top',
              padding: '0 12px 12px 0',
            }}
            onClick={() =>
              selectImage({
                name: 'nutrition_facts_image_url',
                src: images.nutrition_facts_image_url,
              })
            }
          />
        )}

        {images.sell_sheets.length > 0 &&
          images.sell_sheets.map((img, ind) => (
            <Fragment key={img.image_url || ind}>
              {img.image_url?.length > 0 && (
                <Image
                  className={
                    mainImage.name === `image_url-${ind + 1}`
                      ? styles.ThumbnailActive
                      : styles.Thumbnail
                  }
                  src={img.image_url}
                  style={{ objectFit: 'cover', objectPosition: 'left top' }}
                  onClick={() =>
                    selectImage({
                      name: `image_url-${ind + 1}`,
                      src: img.image_url,
                    })
                  }
                />
              )}
            </Fragment>
          ))}
      </div>

      <div className={styles.MainImageContainer}>
        <QuickViewImageBadges {...badgesProps} />
        {mainImage.src ? (
          <Image
            loading="lazy"
            className={styles.MainImage}
            style={{
              maxWidth:
                mainImage.name === 'nutrition_facts_image_url'
                  ? '600px'
                  : undefined,
            }}
            src={mainImage.src}
          />
        ) : null}

        {badgesProps.isDepositProduct && (
          <div className={styles.DepositBadge}>
            <Image src={depositBadgeImage} alt="deposit_badge_image" className='w-100' />
          </div>
        )}
      </div>
    </div>
  );
};

export default QuickViewDesktopGallery;
